import { Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { PermissionGuard } from './auth/permission.guard';
import { MaintenanceGuard } from './auth/maintenance.guard';
import { MaintenancePageGuard } from './auth/maintenance-page.guard';
import { ArticleComponent } from './features/Feed/components/article/article.component';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./auth/auth.route').then((m) => m.authRoutes),
  },
  {
    path: 'home',
    loadComponent: () => import('./features/Home/home.component').then(m => m.HomeComponent),
    canActivate: [AuthGuard, MaintenanceGuard]
  },
  {
    // PROTÓTIPO (dados fictícios) — sem item de menu até a aprovação do negócio.
    path: 'resumo',
    loadChildren: () =>
      import('./features/Resumo/resumo.routes').then((m) => m.RESUMO_ROUTES),
    canActivate: [AuthGuard, MaintenanceGuard]
  },
  {
    path: 'profile',
    loadComponent: () => import('./features/Perfil/components/user-profile/user-profile.component').then(m => m.UserProfileComponent),
    canActivate: [AuthGuard, MaintenanceGuard]
  },
  {
    path: 'configuracoes-sistema',
    loadComponent: () => import('./features/ConfiguracoesSistema/configuracoes-sistema.component').then(m => m.ConfiguracoesSistemaComponent),
    canActivate: [AuthGuard, MaintenanceGuard]
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/Paineis/painel.routes').then((m) => m.PAINEL_ROUTES),
    canActivate: [AuthGuard, PermissionGuard, MaintenanceGuard],
    data: {
      permissoes: ['PAINEIS', 'Admin']
    }
  },
  {
    // O acesso a cada painel de ajuda é decidido pelo menu do usuário (ajudaDashboardGuard).
    path: 'ajuda',
    loadChildren: () =>
      import('./features/Ajuda/ajuda.routes').then((m) => m.AJUDA_ROUTES),
    canActivate: [AuthGuard, MaintenanceGuard]
  },
  {
    path: 'novidades',
    loadChildren: () =>
      import('./features/Feed/feed.route').then((m) => m.FEED_ROUTES),
    canActivate: [AuthGuard, PermissionGuard, MaintenanceGuard],
    data: {
      permissoes: ['FEED', 'Admin']
    }
  },
  // {
  //   path: 'campanhas',
  //   loadChildren: () =>
  //     import('./features/CampanhaAds/campanhaAds.route').then((m) => m.CAMPANHADS_ROUTES),
  //   canActivate: [AuthGuard, PermissionGuard, MaintenanceGuard],
  //   data: {
  //     permissoes: ['CAMPANHAS ADS', 'Admin']
  //   }
  // },
  {
    path: 'novidade/:id',
    loadComponent: () => ArticleComponent,
    canActivate: [AuthGuard, PermissionGuard, MaintenanceGuard],
    data: {
      permissoes: ['FEED', 'Admin']
    }
  },
  {
    path: "entrega",
    loadChildren: () =>
      import('./features/ConsultaPedidos/consulta.routes').then((m) => m.CONSULTA_ROUTES),
    canActivate: [AuthGuard, PermissionGuard, MaintenanceGuard],
    data: {
      permissoes: ['PEDIDOS', 'Admin']
    }
  },
  {
    path: "planos",
    loadComponent: () =>
      import('./features/Planos/planos/planos.component').then(m => m.PlanosComponent),
    canActivate: [AuthGuard, PermissionGuard, MaintenanceGuard],
    data: {
      permissoes: ['PLANOS COMERCIAIS', 'Admin']
    }
  },
  {
    path: "logSistema",
    loadComponent: () =>
      import('./features/Consultas/components/logs-operacao/logs-operacao.component').then(m => m.LogsOperacaoComponent),
    canActivate: [AuthGuard, PermissionGuard, MaintenanceGuard],
    data: {
      permissoes: ['LOG DE OPERACAO', 'Admin']
    }
  },
  {
    path: "logLogin",
    loadComponent: () =>
      import('./features/Consultas/components/logs-login/logs-login.component').then(m => m.LogsLoginComponent),
    canActivate: [AuthGuard, PermissionGuard, MaintenanceGuard],
    data: {
      permissoes: ['LOG DE ACESSO', 'Admin']
    }
  },

  {
    path: "",
    loadChildren: () =>
      import('./features/Cadastro/cadastro.route').then((m) => m.CADASTRO_ROUTES),
    canActivate: [AuthGuard, PermissionGuard, MaintenanceGuard],
    data: {
      permissoes: ['CADASTRO', 'Admin']
    }
  },

  {
    path: "painelControle",
    loadChildren: () =>
      import('./features/PainelDeControle/PainelDeControle.route').then((m) => m.PAINEL_DE_CONTROLE_ROUTES),
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permissoes: ['PAINEL DE CONTROLE', 'Admin']
    }
  },
  {
    path: "exportacoes",
    loadComponent: () => import('./features/Consultas/components/exportacoes/exportacoes.component').then(m => m.ExportacoesComponent),
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permissoes: ['EXPORTACOES', 'Admin']
    }
  },
  {
    path: 'maintenance',
    loadComponent: () => import('./features/PainelDeControle/manutencao/pages/maintenance-page/maintenance-page.component').then(m => m.MaintenancePageComponent),
    canActivate: [MaintenancePageGuard]
  },
  {
    path: '**',
    redirectTo: '404',
  }
];
